import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Params } from '@angular/router';

@Component({
  selector: 'muni-gameday-panel',
  templateUrl: './panel.template.html',
  styleUrls: ['./panel.styles.scss'],
  standalone: false,
})
export class PanelComponent {
  @Input()
  public title: string;
  @Input()
  public linkText: string;
  @Input()
  public linkUrl: string;
  @Input()
  public linkParams: Params;
  @Input()
  public isActive: boolean;
  @Input()
  public condensed = false;
  @Output()
  public readonly linkClick: EventEmitter<Event> = new EventEmitter<Event>();

  public handleClick(event: Event): void {
    this.linkClick.emit(event);
  }
}
